<div class="modal-header bg-light" >
  @switch (estadoNotificaciones){
    @case ( enumEstadoNotificacion.saldoExcedido) {
      <h4 class="modal-title">Crear notificaci&oacute;n saldo excedido</h4>
    }
    @case ( enumEstadoNotificacion.saldoVencido) {
      <h4 class="modal-title">Crear notificaci&oacute;n saldo vencido</h4>
    }
    @case (enumEstadoNotificacion.previoAlExcedido) {
      <h4 class="modal-title">Crear notificaci&oacute;n previo al excedido</h4>
    }
    @default {
      <h4 class="modal-title">Creaci&oacute;n de notificaciones</h4>
    }
  }
  <button type="button" class="btn-close" aria-label="Close" [disabled]="grabando" (click)="activeModal.close(false)"></button>
</div>
@if (!estadoNotificaciones && estadoNotificaciones !== enumEstadoNotificacion.saldoExcedido) {
  <div class="modal-body" >
    <div class="row justify-content-center mb-3">
      <div class="col-auto">
        <button  class="btn btn-primary w-200px" (click)="saldoExcedidoNotificacion();">
          <span>Saldo excedido</span>
        </button>
      </div>
    </div>
    <div class="row justify-content-center mb-3">
      <div class="col-auto">
        <button  class="btn btn-primary w-200px" (click)="saldoVencidoNotificacion();">
          <span>Saldo vencido</span>
        </button>
      </div>
    </div>
    <div class="row justify-content-center mb-3">
      <div class="col-auto">
        <button  class="btn btn-primary w-200px" (click)="previoAlExcedidoNotificacion();">
          <span>Previo al excedido</span>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="modal-body" [formGroup]="crearNotificacionForm" >
        <div class="form-row">
            <div class="form-group row col-12">
                <label for="emailSaldos" class="col-form-label">{{estadoNotificaciones === enumEstadoNotificacion.previoAlExcedido ? 'Email:' : "Destinatarios"}} </label>
            </div>
            <div class="form-group row col-12 mb-3">
                <div class="col-11">
                    <input id="emailSaldos" [disabled]="grabando" class="form-control" formControlName="emailFormControl" maxlength="50">
                    @if (emailFormControl?.errors?.email){
                      <ngb-alert class="mt-2" type="danger" [dismissible]="false">
                        Debe ingresar un email valido.
                      </ngb-alert>
                    } @else if (this.mailExiste){
                      <ngb-alert class="mt-2" type="danger" [dismissible]="false">
                        El email que intenta ingresar ya fue ingresado
                      </ngb-alert>
                    }
                </div>
                <div class="col-1">
                    <button [disabled]="grabando" class="btn btn-outline-primary"
                            ngbTooltip="Agregar Email"
                            (click)="agregarMail()">
                      <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>

            <div class="container-fluid border p-2 mb-3">
              <div class="row col-12">
                <label class="col-form-label" [ngClass]="{ 'col-8': mailsNotificacion.length === 0, 'col-4': mailsNotificacion.length > 0 }">Emails asignados:</label>
                <div class="col-8 card-body">
                  <div *ngFor="let mail of mailsNotificacion; let i = index" class="d-flex mb-2">
                      <label class="col-11 col-form-label text-truncate">{{mail}}</label>
                      <button [disabled]="grabando" ngbTooltip="Quitar mail asignado" class="btn btn-danger col-1 px-1" (click)="borrarMail(i)">
                        <i class="fa fa-trash"></i>
                      </button>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="mailsNotificacion.length === 0">
                <div class="col-12">
                  <ngb-alert class="alert-warning" [dismissible]="true">
                    No ha ingresado ningun email
                  </ngb-alert>
                </div>
              </div>
            </div>

          @if (estadoNotificaciones === enumEstadoNotificacion.previoAlExcedido) {
            <div class="form-row">
              <div class="form-group row col-12">
                <label for="monto" class="col-4 col-form-label">Monto en ARP: </label>
                <div class="col-8 d-flex align-items-center">
                  <i class="fa large fa-usd me-2"></i>
                  <input
                    type="number"
                    [disabled]="grabando"
                    id="monto"
                    class="form-control"
                    formControlName="montoFormControl"
                  />
                </div>
              </div>
            </div>
          } @else {
            <div class="form-group row col-12 mt-4">
                <label for="mensaje" class="col-form-label">Mensaje </label>
            </div>
            <div class="form-group row col-12 mb-3">
              <div class="col-12">
                <textarea
                  id="mensaje"
                  class="form-control"
                  rows="5"
                  maxlength="255"
                  placeholder=""
                  formControlName="mensajeFormControl"
                ></textarea>
                <p id="charCounter" class="mt-1 ms-1"><small>{{mensajeFormControl.value.length}}/255</small></p>
                <div *ngIf="mensajeFormControl.invalid && mensajeFormControl.errors.required && (mensajeFormControl.dirty || mensajeFormControl.touched)"
                  class="alert alert-danger">
                  El mensaje es obligatorio.
                </div>
              </div>
            </div>
         }
        </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button  class="btn btn-primary" id="aceptar"
             [disabled]="mensajeVacio() || !this.mailsNotificacion.length || crearNotificacionForm.invalid || grabando"
             (click)="agregarNotificacion();">
      <span *ngIf="!grabando"> {{estadoNotificaciones === enumEstadoNotificacion.previoAlExcedido ? 'Guardar' : 'Guardar cambios'}}</span>
      <div *ngIf="grabando" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Guardando...</span>
      </div>
    </button>
    @if (estadoNotificaciones === enumEstadoNotificacion.previoAlExcedido){
      <button [disabled]="grabando" type="button" class="btn btn-secondary" (click)="this.activeModal.close(false)">Cancelar</button>
    }
  </div>
}
